import { END_USERS } from "../../API/UserApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import apiHeader from "../../Components/ApiHeader";

export const deleteUsersAPI: any = createAsyncThunk(
  "deleteUser",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.delete(END_USERS + "/" + rowId, {
        headers: commonHead,
      });
      return { userDeleted: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
